module.exports = __webpack_public_path__ + "media/src/assets/signup_hands-30f04ab0052ee1a0ab288e19ab5f3359.svg";